import { render, staticRenderFns } from "./Gastos.vue?vue&type=template&id=dae29dce&scoped=true"
import script from "./Gastos.vue?vue&type=script&lang=js"
export * from "./Gastos.vue?vue&type=script&lang=js"
import style0 from "./Gastos.vue?vue&type=style&index=0&id=dae29dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae29dce",
  null
  
)

export default component.exports